module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/kitchen/logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/kitchen/logo.jpg
// module id = 583
// module chunks = 0